import React from 'react';
import { useRouter } from 'next/router';
import ProductDetail from '../components/Products/ProductDetail';
import productQuery from '../lib/queries/products/productQuery.graphql';
import withApollo from '../lib/apollo';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import {
  productAnchorImageConfigurations,
  productLightboxImageConfigurations,
} from '../lib/imageConfigurations';

const FashionFinderProductPage = () => {
  const {
    query: {
      id,
      slug,
    },
  } = useRouter();
  const variables = {
    id: Number(id),
    slug,
    anchorImageConfigurations: productAnchorImageConfigurations,
    lightboxImageConfigurations: productLightboxImageConfigurations,
  };

  return (
    <ProductDetail
      variables={variables}
      query={productQuery}
      passErrors={['Access denied']}
      errorMessage="Error loading this product detail"
      hasBreadCrumbs={false}
      backToProductsRoute="fashion-finder-profile"
      buyText
      {...variables}
    />
  );
};

FashionFinderProductPage.getLayout = (page) => page;

FashionFinderProductPage.getInitialProps = redirectRouteToDomain(
  'fashion-finder-profile',
);

export default withApollo(FashionFinderProductPage);
